// React
import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

// Libraries
import { Drawer as DrawerPrimitives } from 'vaul'

// Components
import * as DrawerBlocks from 'ui/blocks/Picker/Drawer'
import Icon from 'ui/components/Icon'

export const Root = ({ open, onOpenChange, children, ...props }) => (
  <DrawerPrimitives.Root open={open} onOpenChange={onOpenChange} {...props}>
    <DrawerPrimitives.Portal>
      <DrawerBlocks.Overlay />
      <DrawerBlocks.Content aria-describedby={undefined}>{children}</DrawerBlocks.Content>
    </DrawerPrimitives.Portal>
  </DrawerPrimitives.Root>
)

Root.propTypes = {
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  children: PropTypes.node
}

Root.displayName = 'Drawer.Root'

export const Header = forwardRef(({ children, ...props }, ref) => (
  <DrawerBlocks.Header ref={ref} {...props}>
    <DrawerBlocks.Close>
      <DrawerPrimitives.Close data-tid="Drawer close" asChild>
        <Icon icon="times" />
      </DrawerPrimitives.Close>
    </DrawerBlocks.Close>
    {children}
  </DrawerBlocks.Header>
))

Header.propTypes = {
  children: PropTypes.node
}

Header.displayName = 'Drawer.Header'

export const Title = ({ children, ...props }) => <DrawerBlocks.Title {...props}>{children}</DrawerBlocks.Title>

Title.propTypes = {
  children: PropTypes.node
}

Title.displayName = 'Drawer.Title'

export const Body = forwardRef(({ children, ...props }, ref) => (
  <DrawerBlocks.Body ref={ref} {...props}>
    {children}
  </DrawerBlocks.Body>
))

Body.propTypes = {
  children: PropTypes.node
}

Body.displayName = 'Drawer.Body'
